// Sanitize a string for use in a filename — keep letters, digits, dashes, underscores.
// Romanian diacritics are stripped to ASCII.
const stripDiacritics = (s) =>
  (s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[ĂÂ]/gi, "A")
    .replace(/Î/gi, "I")
    .replace(/[ȘŞ]/gi, "S")
    .replace(/[ȚŢ]/gi, "T");

export const safeSlug = (s, max = 60) => {
  const cleaned = stripDiacritics(s)
    .replace(/[^A-Za-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, max);
  return cleaned || "document";
};

/**
 * Build a download filename in the form: `{Kind} {Denumire} {Numar}.{ext}`
 * Example: `Contract ZON LIME SRL DD902.pdf` or `PV CREADOR AGENCY SRL 800-PV-6.pdf`
 * @param {"contract"|"pv"|"contracts"|"pvs"|string} kind
 * @param {object} client — must have `denumire`
 * @param {string|number} numar — document number
 * @param {string} ext — extension without dot (default "pdf")
 */
export const buildDocFilename = (kind, client, numar, ext = "pdf") => {
  const k = String(kind || "").toLowerCase();
  const label = k.startsWith("contract") ? "Contract" : k.startsWith("pv") ? "PV" : String(kind || "");
  const nameRaw = stripDiacritics(client?.denumire || "").replace(/[^A-Za-z0-9 ]+/g, " ").replace(/\s+/g, " ").trim();
  const numRaw = stripDiacritics(String(numar || "")).replace(/[^A-Za-z0-9\-]+/g, "-").replace(/^-+|-+$/g, "");
  const parts = [label, nameRaw, numRaw].filter(Boolean);
  return `${parts.join(" ")}.${ext}`;
};
